export default "__VITE_ASSET__c21d53e1__"